import axios from "axios";
import { ENDPOINTS } from "./_config";

const authToken = sessionStorage.getItem("authToken");
export async function fetchMetaIntegrationExistData(setValue) {
    const url = ENDPOINTS.FBINTEGRATION.GET_FB_INTEGRATION;

    try {
        const response = await axios.get(url);

        setValue(response.data?.data);
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);
        return null;
    }
}

export async function fetchMicrosoftIntegrationExistData(setValue) {
    const url = ENDPOINTS.CALENDAR.MICROSOFT_EXIST;

    try {
        const response = await axios.get(url);

        setValue(response.data?.data);
    } catch (error) {
       
        console.error("Error fetching data:", error.response?.data || error.message);
        return null;
    }
}

export const metaLogin = async (data, setValue) => {
    const url = ENDPOINTS.FBINTEGRATION.META_LOGIN;

    try {
        const response = await axios.post(url, null, {
            params: {
                appId: data.appId,
                appSecret: data.appSecret,
                redirectUri: data.redirectUri
            }
        });
        response.data && response.data.data && response.data.data.uri && setValue(response.data.data.uri);
    } catch (error) {
       
        console.error("Error fetching API:", error.response?.data || error.message);
    }
};

export const fetchMetaAdsData = async (accessToken, setData) => {

    try {
        if (!accessToken) {
            throw new Error("Access Token not found in URL");
        }

        // Construct API URL with accessToken as a query parameter
        const apiUrl = `${ENDPOINTS.FBINTEGRATION.FETCH_META_ADS_DATA}?accessToken=${accessToken}`;
        const authToken = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");


        if (!authToken) {
            throw new Error("Auth Token not found in sessionStorage");
        }

        // Correct axios POST request with headers
        const response = await axios.post(apiUrl);

        setData(response.data.data)
        return response.data;
    } catch (error) {
        return null;
    }
};

export async function postMetaAccountSelection(metaAdCredentialID, accountId, adAccountId) {
    const url = `${ENDPOINTS.FBINTEGRATION.POST_META_ACCOUNT_SELECTION}?metaAdCredentialID=${metaAdCredentialID}&accountId=${accountId}&adAccountId=${adAccountId}`;

    try {
        const response = await axios.post(url, {}); // Pass payload if needed
        
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function disconnectMetaIntegration(metaAdCredentialID) {
    const url = `${ENDPOINTS.FBINTEGRATION.DELETE_META_EXIST}?metaAdCredentialID=${metaAdCredentialID}`;

    try {
        const response = await axios.post(url, {}); // Pass payload if needed
        
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function disconnectMicrosoftIntegration() {
    const url = `${ENDPOINTS.CALENDAR.DISCONNECT_MICROSOFT_ACCOUNT}`;

    try {
        const response = await axios.post(url, {}); // Pass payload if needed
        
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}




export async function getUnassignedMetaAdForm(setData) {
    const url = `${ENDPOINTS.FBINTEGRATION.GET_UNASSIGNED_METAADFORM}`
    

    try {
        const response = await axios.get(url);

        if (response && response.data && response.data.data) {
            setData(response.data.data);
            return response.data.data;
        }

        return null; // Return null explicitly if no data is found
    } catch (error) {
        console.error('Error fetching meta ad form:', error);
        throw error;
    }
}

export async function linkMetaAdFormTrial(payload) {
    const url = ENDPOINTS.FBINTEGRATION.LINK_METAADFORM_TRIAL;

    try {
        const response = await axios.post(url, payload);

        return response.data;
    } catch (error) {
        console.error("Error linking Meta Ad Form trial:", error);
        return null;
    }
}


export async function getTrialAdFormJunctionList(trialID) {
    const url = `${ENDPOINTS.FBINTEGRATION.GET_METAADS_BY_TRIAL_ID}?TrialID=${trialID}`;

    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching trial ad form junction list:", error);
        return null;
    }
}



export const deleteMetaAd = async (id) => {
    try {
        const response = await axios.delete(
            `${ENDPOINTS.FBINTEGRATION.DELINK}`,
            {
                data: [id] // Payload as an array
            }
        );

        return response.data;
    } catch (error) {
        console.error("Delete failed:", error);
        throw error;
    }
};
